import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { prop } from 'ramda';

import { useUserSelector } from 'js/store/hooks';
import { useIsAdmin } from 'js/hooks/user/hooks/useIsAdmin';
import { userSetAttributesAction } from 'js/hooks/user/store/actions';

/* core, added deps role (line 18) */
export const useAdminRole = () => {
    const isAdmin = useIsAdmin();
    const dispatch = useDispatch();
    const role = useUserSelector(prop('role'));

    useEffect(() => {
        if (isAdmin) {
            dispatch(userSetAttributesAction({ role: 'admin' }));
        }
    }, [isAdmin, dispatch, role]);
};
